export default {
  keyFields: ({ companyId: id }, { typename }) => `${typename}_${id}`,
};
